import { get } from 'lodash';

import { Agent } from 'src/actions/agent/agentsResource';
import { Account, AccountType } from 'src/actions/accounts/accountsResource';
import { FacebookPage } from 'src/models/Facebook/FacebookPage';

export function findUnassociatedFacebookPages(
  unFilteredAccounts: Array<Account>,
  fbPages: Array<FacebookPage>,
  accountType: AccountType
): Array<FacebookPage> {
  if (!fbPages) {
    return [];
  }

  const filterFbPages = fbPages.filter(fbPage => {
    switch (accountType) {
      case AccountType.InstagramDirect:
      case AccountType.Instagram:
        return !!fbPage.instagram_business_account?.id;
      default:
        return true;
    }
  });

  const account = unFilteredAccounts.filter(account => account.type === accountType);
  const unassociatedFacebookPages = new Array<FacebookPage>();
  filterFbPages.forEach(fbPage => {
    let found = false;
    account.forEach(account => {
      switch (accountType) {
        case AccountType.FacebookMessenger:
          if (fbPage.id === account.content.id) {
            found = true;
          }
          break;
        case AccountType.InstagramDirect:
        case AccountType.Instagram:
          if (
            fbPage.id === account.content.id &&
            fbPage.instagram_business_account?.id === account.content.instagramBusinessAccount?.id
          ) {
            found = true;
          }
          break;
      }
    });
    if (!found) {
      unassociatedFacebookPages.push(fbPage);
    }
  });
  return unassociatedFacebookPages;
}

export function findAccountCreatorName(account: Account, agents: Array<Agent>) {
  const agent = agents.find(agent => agent.id === get(account, 'createdBy.userId'));
  return agent ? agent.name : '';
}

export function accountsFilter(accounts, searchString) {
  if (!searchString) {
    return accounts;
  }
  return accounts.filter(account => {
    const name = get(account, 'content.name');
    if (!name) {
      return false;
    }
    return name.indexOf(searchString) !== -1;
  });
}
